'use strict';

angular.module('imagetrend.components')
    .directive('hlpTypeahead', ['$rootScope', '$templateCache', 'Validation', '$q', '$filter', '$injector', '$timeout', function ($rootScope, $templateCache, Validation, $q, $filter, $injector, $timeout) {
        return {
            scope: {
                // strings
                name: '@?',
                id: '@?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                classes: '@?',
                instructions: '@?',
                blankText: '@?',
                selectShow: '@?',
                selectSort: '@?',
                selectValue: '@?',
                availableShow: '@?',
                availableSort: '@?',
                compareValue: '@?',
                arrayValue: '@?',
                service: '@?',
                method: '@?',
                groupBy: '@?',
                size: '@?',
                maxLength: '@?',
                placeholder: '@?',
                needed: '@?',

                // bools
                showBlank: '=?',
                showLabel: '=?',
                topLabel: '=?',
                showColon: '=?',
                modal: '=?',
                isRequired: '=?',
                showRequired: '=?',
                isDisabled: '=?',
                forceString: '=?',
                serviceOverride: '=?',
                multiple: '=?',
                sortable: '=?',
                vertical: '=?',
                pdf: '=?',
                innerForm: '=?',
                addCourseModal: '=?',

                // typahead.js
                ngModel: '=?',
                question: '=?',
                showValue: '=?',
                ngChange: '&?',
                validation: '=?',
                options: '=?',
                parameters: '=?',
                filterArray: '=?',
                onType: '&?',
                searchBy: '=?'//For when the options are objects but you only need to search by one property in that object
            },
            require: 'ngModel',
            transclude: true,
            template: function () {
                return $templateCache.get('templates/typeahead/typeahead.html');
            },
            compile: function (elem, attrs) {
                return {
                    pre: function (scope, elem, attrs, ngModel) {
                        scope.directiveAttributes = attrs;
                        scope.dirOptions = [];
                        if (scope.getDescendantProp === undefined && scope.id === 'inspection_license_level_service') {
                            scope.getDescendantProp = function (obj, selectShow) {
                                return obj[selectShow];
                            };
                            if (scope.options !== null && scope.options !== undefined) {
                                scope.dirOptions = scope.options;
                            }
                        }
                        if (!scope.directiveAttributes.selectShow) { scope.selectShow = 'name'; }
                        if (!scope.directiveAttributes.selectValue) { scope.selectValue = 'id'; }
                    },
                    post: function (scope, elem, attrs, ngModel) {
                        scope.timeouts = [];

                        scope.valueChange = function (viewValue) {
                            scope.ngModel = null;
                            scope.showValue = null;
                            scope.viewValue = viewValue;
                            if (scope.onType != null) {
                                scope.onType({ viewValue: viewValue });
                            }
                            scope.timeouts.push($timeout(function () {
                                if (scope.validation) {
                                    Validation.validateQuestion(scope.innerForm.input, scope.validation, ngModel.$modelValue);
                                }
                                if (scope.question !== undefined && scope.question.answer !== undefined) {
                                    scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                                }
                            }, 0));
                        }

                        var searchTimeout = null;
                        scope.getOptions = function (viewValue) {
                            if (scope.service != null && scope.service != '' && (scope.method == 'search' || scope.method == 'searchByService' || scope.method == 'searchUsersNotInService' || scope.directiveAttributes.method == 'searchVehiclesNotInService' || scope.directiveAttributes.method == 'getServiceVehicles')) {
                                var service = $injector.get(scope.service);
                                if (searchTimeout != null) {
                                    searchTimeout.resolve();
                                    searchTimeout = null; 
                                }
                                searchTimeout = $q.defer();

                                if (scope.method == 'searchByService') {
                                    if (scope.service == 'Vehicles') {
                                        return service[scope.method]({
                                            search: viewValue,
                                            service_id: scope.parameters.service_id,
                                            limit_vehicle_type_ids: scope.question.parameters.limit_vehicle_type_ids,
                                            show_vehicles_without_type: scope.question.parameters.show_vehicles_without_type
                                        }, searchTimeout).then(function (data) {
                                            searchTimeout = null;
                                            if (data != null) {
                                                scope.dirOptions = data;
                                                scope.options = data;
                                                return $filter('limitTo')($filter('filter')(scope.dirOptions, scope.filterAdded), 8);
                                            }
                                        });
                                    }
                                    else
                                    {
                                        return service[scope.method]({
                                            search: viewValue,
                                            service_id: scope.parameters.service_id
                                        }, searchTimeout).then(function (data) {
                                            searchTimeout = null;
                                            if (data != null) {
                                                scope.dirOptions = data;
                                                scope.options = data;
                                                return $filter('limitTo')($filter('filter')(scope.dirOptions, scope.filterAdded), 8);
                                            }
                                        });
                                    }
                                }
                                if (scope.method == 'searchUsersNotInService' || scope.method == 'searchVehiclesNotInService') {
                                    return service[scope.method]({ search: viewValue, service_id: scope.parameters.service_id, vehicle_restrict_services: scope.parameters.vehicle_restrict_services }, searchTimeout).then(function (data) {
                                        searchTimeout = null;
                                        if (data != null) {
                                            scope.dirOptions = data;
                                            scope.options = data;
                                            return $filter('limitTo')($filter('filter')(scope.dirOptions, scope.filterAdded), 8);
                                        }
                                    });
                                }
                                else {
                                    return service[scope.method]({ search: viewValue }, searchTimeout).then(function (data) {
                                        searchTimeout = null;

                                        if (data != null) {
                                            scope.dirOptions = data;
                                            scope.options = data;
                                            return $filter('limitTo')($filter('filter')(scope.dirOptions, scope.filterAdded), 8);
                                        }
                                    });
                                }
                            }
                        }
                        
                        scope.filterAdded = function (item) {
                            var show = true;

                            if (scope.filterArray != null) {
                                scope.filterArray.forEach(function (f) {
                                    if (!f.license_category_level_id && f.id == item.id) {
                                        show = false;
                                    } else if (f.license_category_level_id && f.license_category_level_id === item.license_category_level_id) {
                                        show = false;
                                    }
                                })
                            }

                            return show;
                        }

                        scope.filterSearchByAndViewValue = function (item) {
                            var show = true;

                            if (scope.directiveAttributes.searchBy && scope.viewValue) {
                                var searchByProperty = scope.directiveAttributes.searchBy;
                                var itemValue = scope.getDescendantProp(item, searchByProperty);

                                if (!itemValue || !itemValue.toLowerCase().includes(scope.viewValue.toLowerCase())) {
                                    show = false;
                                }
                            }

                            return show;
                        };

                        scope.setShowValue = function () {
                            if (ngModel.$modelValue != null) {
                                var val = scope.selectValue == "OBJECT" ? scope.getDescendantProp(ngModel.$modelValue, scope.selectValue) : ngModel.$modelValue;
                                scope.dirOptions.forEach(function (opt) {
                                    var optVal = scope.getDescendantProp(opt, scope.selectValue);
                                    if (val == optVal || ngModel.$modelValue == optVal) {
                                        scope.showValue = scope.getDescendantProp(opt, scope.selectShow);
                                        scope.viewValue = scope.showValue;
                                    }
                                })
                            }
                        }

                        scope.$watch('optionsLoaded', function (optionsLoaded) {
                            if (optionsLoaded && scope.showValue == null) {
                                scope.setShowValue();
                            } else if (scope.showValue !== null && scope.showValue !== undefined && scope.dirOptions.length) {
                                scope.viewValue = scope.showValue;

                            } else if (scope.showValue !== null && scope.showValue !== undefined && scope.dirOptions.length === 0) {
                                scope.viewValue = scope.showValue;
                                scope.dirOptions = scope.getOptions(scope.viewValue);
                            }

                            scope.timeouts.push($timeout(function () {
                                if (scope.innerForm !== undefined) {
                                    if (scope.validation) {
                                        Validation.validateQuestion(scope.innerForm.input, scope.validation, ngModel.$modelValue);
                                    }
                                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                                        scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                                    }
                                }
                            }, 0));
                        });

                        ngModel.$render = function () {
                            scope.timeouts.push($timeout(function() {
                                if (ngModel.$modelValue != null) {
                                    if (scope.selectValue == "OBJECT") {
                                        scope.viewValue = scope.getDescendantProp(ngModel.$modelValue, scope.selectShow);
                                        scope.showValue = scope.viewValue;
                                    }
                                    else {
                                        if (scope.showValue == null && scope.optionsLoaded) {
                                            scope.setShowValue();
                                        }
                                        else if (scope.showValue != null) {
                                            scope.viewValue = scope.showValue;
                                        }
                                    }
                                    if (scope.validation) {
                                        Validation.validateQuestion(scope.innerForm.input, scope.validation, ngModel.$modelValue);
                                    }
                                    if (scope.question !== undefined && scope.question.answer !== undefined) {
                                        scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                                    }
                                }
                                else {
                                    scope.valueChange(null);
                                }
                            }, 0));
                        }

                        scope.intialValidation = function () {
                            if (scope.innerForm !== undefined) {
                                if (scope.question !== undefined && scope.question.answer !== undefined) {
                                    scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                                }
                            }
                        };

                        scope.onChange = function (value, viewValue) {
                            scope.submitted = false;
                            if (scope.selectValue == "OBJECT") {
                                ngModel.$setViewValue(value);
                                scope.showValue = viewValue;
                            }
                            else {
                                ngModel.$setViewValue(scope.getDescendantProp(value, scope.selectValue));
                                scope.ngModel = ngModel.$modelValue;
                                scope.showValue = viewValue;
                            }
                            scope.timeouts.push($timeout(function() {
                                if (scope.validation) {
                                    Validation.validateQuestion(scope.innerForm.input, scope.validation, ngModel.$modelValue);
                                }
                                if (scope.question !== undefined && scope.question.answer !== undefined) {
                                    scope.question.answer.invalid = !isEmpty(scope.innerForm.input.$error);
                                }
                            }, 0));
                        }

                        scope.submitted = false;
                        scope.$on('form:submit', function () {
                            scope.intialValidation();
                            scope.submitted = true;
                        });

                        scope.$on('$destroy', function () {
                            scope.timeouts.forEach(function (timer) {
                                $timeout.cancel(timer);
                            });
                        });
                    }
                }
            }
        };
    }])
;